export default "__VITE_ASSET__wFF_bZUo__"